import React from "react";
import {flatten} from "lodash";
import {Navigate, useParams} from "react-router-dom";

import {RequiredUserPermissionsSome} from "../../atoms/admin-user-permissions/RequiredUserPermissionsSome";
import {DocumentTitle} from "../../atoms/document-title";
import {Banner} from "../../atoms/banner";
import {ReportContextConsumer} from "./ReportContext";
import {getSectionItemsPermissions} from "./permissions.helpers";
import {
  analyticsResidentsAdmissionSection,
  analyticsResidentsArbitrationSection,
  analyticsResidentsMedicaidSection,
  analyticsResidentsMedicareSection,
  analyticsStaffAdmissionSection,
  DEFAULT_OTHER_SECTION_ID,
  reportsSlideAnswersAdmissionSection,
  reportsSlideAnswersAdvancedDirectiveSection,
  reportsSlideAnswersFuneralSection,
  reportsSlideAnswersLaundrySection,
  reportsSlideAnswersMedicaidSection,
  reportsSlideAnswersMedicareSection,
  reportsSlideAnswersSurrogateSection,
  reportsSlideAnswersTrustFundSection,
  reportsSlideAnswersVaccinesSection,
  reportsStaffAdmissionSection,
} from "./constants";
import {ReportingLayout} from "./reporting-layout";
import {otherSectionById} from "./otherReportingSections";
import {reportingListPath} from "./reporting-paths";
import {ReportingListUrlSync} from "./ReportingListUrlSync";

const otherSections = [
  analyticsResidentsAdmissionSection,
  analyticsResidentsArbitrationSection,
  analyticsResidentsMedicaidSection,
  analyticsResidentsMedicareSection,
  analyticsStaffAdmissionSection,
  reportsSlideAnswersAdmissionSection,
  reportsSlideAnswersTrustFundSection,
  reportsSlideAnswersLaundrySection,
  reportsSlideAnswersVaccinesSection,
  reportsSlideAnswersSurrogateSection,
  reportsSlideAnswersAdvancedDirectiveSection,
  reportsSlideAnswersFuneralSection,
  reportsSlideAnswersMedicareSection,
  reportsSlideAnswersMedicaidSection,
  reportsStaffAdmissionSection,
];

const pagePermissions = getSectionItemsPermissions(
  flatten(otherSections.map(section => section.sectionItems)),
);

export const PageReportingOther = () => {
  const {sectionId, from1, to1} = useParams<{
    sectionId: string;
    from1?: string;
    to1?: string;
  }>();
  const Section = sectionId ? otherSectionById[sectionId] : undefined;

  if (!Section) {
    return (
      <Navigate
        to={reportingListPath("other", DEFAULT_OTHER_SECTION_ID)}
        replace
      />
    );
  }

  return (
    <ReportingLayout>
      <ReportingListUrlSync from1={from1} to1={to1} />
      <DocumentTitle title={"Reside - Admin - Reporting | Other"} />
      <RequiredUserPermissionsSome
        permissions={pagePermissions}
        noPermissionChildren={
          <Banner title="No reports are available for this section.">
            <p>Please choose a different report from the left menu.</p>
          </Banner>
        }
      >
        <ReportContextConsumer>
          {({baseDateRange, activeFacilitiesIds}) => (
            <Section
              baseDateRange={baseDateRange}
              activeFacilitiesIds={activeFacilitiesIds}
            />
          )}
        </ReportContextConsumer>
      </RequiredUserPermissionsSome>
    </ReportingLayout>
  );
};
